import { createLogger } from './logger'
import { WsClient } from './ws-client'
import { PrintManager as PM } from './print-manager'
import type { SDKConfig, Client, PrintManager } from './types'
import { SDK_VERSION } from './types'

/**
 * 创建 WebSocket 客户端
 * @param cfg WebSocket 配置
 * @param loggerLevel 日志级别
 */
export function createClient(cfg: SDKConfig['ws'], loggerLevel: 'debug'|'info'|'warn'|'error' = 'info'): Client {
  const logger = createLogger(loggerLevel)
  return new WsClient(cfg, logger)
}

/**
 * 创建打印管理器
 * @param client WebSocket 客户端实例
 * @param renderer 模板渲染函数（可选）
 */
export function createPrintManager(client: Client, renderer?: (tpl:any, data:any, opts:any)=>Promise<Uint8Array>): PrintManager {
  return new PM(client, renderer)
}

/** SDK 版本号 */
export const version = SDK_VERSION

/** 导出类型以供外部使用 */
export type { SDKConfig, Client, PrintManager }
